import { QueryFunctionContext } from '@tanstack/react-query';
import { api } from '../services/api';
import { IDataNoPagination } from '../types/shared';

export interface IEfdErroDetalhe {
  id: number;
  tipo_pendencia: string | null;
  erro_descricao: string | null;
  erro_descricao_normalizada: string | null;
  erro_quantidade: number | null;
  erro_categoria: string | null;
  arquivo_pdf: string | null;
  s3_url: string | null;
}

export interface IEfdErrosEmpresa {
  empresa_id: string;
  cnpj: string | null;
  contribuinte: string | null;
  periodo_inicio: string | null;
  periodo_fim: string | null;
  data_validacao: string | null;
  total_pendencias: number;
  erros: IEfdErroDetalhe[];
}

export interface IEfdErrosCategoria {
  categoria: string;
  quantidade: number;
  empresas: number;
}

export interface IEfdErrosKpi {
  total_pendencias: number;
  total_erros: number;
  total_avisos: number;
  total_empresas: number;
  categorias: IEfdErrosCategoria[];
}

export interface IEfdErrosAgrupados {
  items: IEfdErrosEmpresa[];
  total: number;
  page: number;
  page_size: number;
}

export const useEfdErros = () => {
  const getErrosAgrupados = async (
    key: QueryFunctionContext,
  ): Promise<IDataNoPagination<IEfdErrosAgrupados>> => {
    const filters = key.queryKey?.[1] ?? {};
    const res = await api.get<IDataNoPagination<IEfdErrosAgrupados>>(
      '/api/v1/efd-erros-validacao/agrupado',
      { params: filters },
    );
    return res.data;
  };

  const getKpi = async (key: QueryFunctionContext): Promise<IDataNoPagination<IEfdErrosKpi>> => {
    const filters = key.queryKey?.[1] ?? {};
    const res = await api.get<IDataNoPagination<IEfdErrosKpi>>('/api/v1/efd-erros-validacao/kpi', {
      params: filters,
    });
    return res.data;
  };

  return {
    getErrosAgrupados,
    getKpi,
  };
};
